import { InMemoryCache } from '@apollo/client';

import demoTournamentFeaturesMock from 'mocks/demoTournaments/demoTournamentFeatures';
import demoLevelConfigMock from 'mocks/demoTournaments/demoTournamentLevelConfig';
import { demoTournamentsMock } from 'mocks/demoTournaments/demoTournaments';
import demoPoliciesMock from 'mocks/policies/demoPolicies';
import { getMockTournamentListingFromTournamentRecord } from 'mocks/tournaments/tournamentsList';
import { isStandalone } from 'utils/environment';

export const cache = new InMemoryCache({
  typePolicies: {
    FullTournament: {
      keyFields: ['$clubSparkTournamentId'],
    },
    GetSettings: {
      keyFields: ['$personId', '$tournamentId'],
    },
    ...(isStandalone() && {
      Query: {
        fields: {
          tournamentPolicies: {
            read() {
              return demoPoliciesMock;
            },
          },
          isUserAdminWithTournamentScope: {
            read() {
              return true;
            },
          },
          listSuspensionCodes: {
            read() {
              return [];
            },
          },
          tournamentFeatures: {
            read() {
              return demoTournamentFeaturesMock;
            },
          },
          tournamentLevelConfig: {
            read() {
              return demoLevelConfigMock;
            },
          },
          fullTournament: {
            read(existing, { args: { clubSparkTournamentId } }) {
              const mockedTournament = demoTournamentsMock.items.find(
                (item) => item.tournamentId === clubSparkTournamentId,
              );

              return {
                tournaments: [mockedTournament],
              };
            },
          },
          draftTournaments: {
            // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
            read(existing, { args: { paginationOptions, tournamentFilters } }) {
              return {
                totalItems: demoTournamentsMock.items.length,
                items: demoTournamentsMock.items.map((tournament) =>
                  getMockTournamentListingFromTournamentRecord(tournament),
                ),
              };
            },
          },
          settings: {
            read() {
              return {
                tournamentId: 'tournamentId',
                personId: 'personId',
                draw: {
                  additionalPlayerInformation: ['CITY_STATE'],
                  matchDayInformation: [],
                  playerAdornment: 'WTN',
                  showEntryStatus: false,
                },
                tournamentDeskUI: {},
              };
            },
          },
        },
      },
    }),
  },
});
